import { Stage } from "../core/stage";

export class StageFactory {
    constructor(StageCtor = Stage, depsFactory) {
        this.StageCtor = StageCtor, this.depsFactory = depsFactory;
    }
    create(params = {}) {
        var _a;
        return new this.StageCtor(params, null === (_a = this.depsFactory) || void 0 === _a ? void 0 : _a.call(this));
    }
}
//# sourceMappingURL=stage-factory.js.map
